import React from "react";
import { useAppSelector, useAppTranslation } from "@/utils";
import { Button, Drawer, Form, Input, Space, Typography } from "@payping/web-components";
import { DashboardChecksTypeEnum } from "@payping/api";
import { Close } from "@payping/icons";
import EditActionButtons from "@/components/mobile/settings/EditActionButtons";
import { DashboardRoutes } from "@/router/constant";
import { useHandleNavigationURL, useSaveToRedux } from "../../utils";
import { settingsBusinessAtom } from "@/mobile/Settings/state";
import { selectAtom } from "jotai/utils";
import { useAtom } from "jotai";

const mobileFormEditAtom = selectAtom(settingsBusinessAtom, (val) => val.mobileFormEdit);

const MobileEditOfficialBusinessNationalCode: React.FC = () => {
  const { t } = useAppTranslation();
  const [form] = Form.useForm();
  const checks = useAppSelector((state) => state.user.checks);
  const isBusinessDisabled = checks?.businessStatus === DashboardChecksTypeEnum.Confirmed;
  const [mobileFormEditState] = useAtom(mobileFormEditAtom);

  const nationalCodeApi = useAppSelector((state) => state.user.businessInfo?.bNationalCode);

  // Custom Hooks
  const { saveToRedux } = useSaveToRedux();
  const { handleNavigationURL } = useHandleNavigationURL();

  return (
    <>
      <Drawer
        placement={"bottom"}
        open={true}
        height={"100%"}
        title={`${t("edit")} / ${t("profile.bNationalCode")}`}
        closeIcon={false}
        extra={<Button type={"text"} icon={<Close width={14} height={14} />} onClick={handleNavigationURL} />}
      >
        <Space direction={"vertical"}>
          <Form
            onFinish={({ bNationalCode }) =>
              saveToRedux({
                nextUrlForMobileRegisterURL: DashboardRoutes.register.mEditBusiness.officialBusinessEconomicCode.url,
                nextUrlForEdit: DashboardRoutes.settings.mEditBusiness.officialBusinessEconomicCode.url,
                fieldName: "bNationalCode",
                fieldValue: bNationalCode,
                setIsDrawerOpen: () => {},
              })
            }
            form={form}
            initialValues={{ bNationalCode: mobileFormEditState.bNationalCode ?? nationalCodeApi }}
          >
            <Form.Item
              label={t("profile.bNationalCode")}
              name="bNationalCode"
              rules={[{ len: 11 }, { required: true }]}
            >
              <Input
                onlyNumbers
                disabled={!form.getFieldValue("bNationalCode") ? false : isBusinessDisabled}
                canStartWithZero
              />
            </Form.Item>
          </Form>
          <Typography.Text type={"secondary"}>{t("mobileEditPersonal.nameDesc")}</Typography.Text>
        </Space>
      </Drawer>
      <EditActionButtons onAccept={form.submit} acceptText={t("next")} />
    </>
  );
};

export default MobileEditOfficialBusinessNationalCode;
